import { render } from "./SidebarMenu.vue?vue&type=template&id=402a8a99"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_a3ee6c512411489faef2ecfce652dcca/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__